import { Pipe, PipeTransform } from '@angular/core';
import { Identifiable } from '@t-llevo/util';

@Pipe({
  name: 'excludeSelected',
  standalone: true,
})
export class ExcludeSelectedPipe<T extends Identifiable>
  implements PipeTransform
{
  transform(value: readonly T[], selected: number[]): T[] {
    return value.filter((it) => !selected.includes(+it.id));
  }
}
